import { FC, useCallback, useMemo, useState } from "react";

import { AttentionBanner, Icon } from "../../common";
import { OnmetaKYCModal } from "../../modals";

type Props = {
  show?: boolean;
  setShow?: (show: boolean) => void;
  defaultShow?: boolean;
};

export const GetVerifiedOnmetaBanner: FC<Props> = ({
  show,
  setShow,
  defaultShow,
}) => {
  const [innerShow, setInnerShow] = useState(defaultShow || false);
  const currentShow = useMemo(() => show || innerShow, [show, innerShow]);

  const handleOpen = useCallback(() => {
    if (setShow) {
      setShow(true);
    } else {
      setInnerShow(true);
    }
  }, [setShow]);

  const handleClose = useCallback(() => {
    if (setShow) {
      setShow(false);
    } else {
      setInnerShow(false);
    }
  }, [setShow]);

  return (
    <div className="w-[340px] h-[244px]">
      <AttentionBanner
        heading={
          <div className="flex items-center gap-4">
            <Icon icon="KYC" size={24} />
            Get verified at Onmeta
          </div>
        }
        action={{
          label: "Verify",
          onClick: handleOpen,
        }}
      >
        To receive INR payouts.
      </AttentionBanner>

      {currentShow && (
        <OnmetaKYCModal isOpen={currentShow} close={handleClose} />
      )}
    </div>
  );
};
